// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .dashboard_main {
    margin-top: 5.5rem;
} */

/* .dashboard {
    margin-left: 23.25rem;
} */

.countdown-circle {
    /* stroke-dasharray: 113;
    stroke-dashoffset: 0;
    animation: countdown 2400s linear forwards; */
    width: 120px;
    height: 120px;
    gap: 0px;
    opacity: 0px;
    margin: 0 auto;
}

.countdown-circle img {
    width: 120px;
    height: 120px;
    /* top: 76px;
    left: 52px; */
    gap: 0px;
    opacity: 0px;

}

.pointer {
    /* animation: rotate-pointer 2400s linear forwards; */
    /* transform-origin: center; */
    width: 27.83px;
    height: 27.83px;
    gap: 0px;
    opacity: 0px;

}

.pointer .pointer_img {
    width: 27.83px;
    height: 27.83px;
    gap: 0px;
    opacity: 0px;
    position: relative;
    top: -88px;
    left: 0px;
}

.remaining_time {
    display: flex;
    width: 69px;
    height: 43px;
    top: -80.625%;
    left: 21.6%;
    gap: 1.39px;
    opacity: 0px;
    position: relative;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
}

.remaining_time .time {
    width: 82px;
    height: 34px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 20px;
    font-weight: 600;
    line-height: 33.4px;
    text-align: center;
    color: #151D48;
}

.remaining_time .text {
    width: 77px;
    height: 26px;
    gap: 0px;
    opacity: 0px;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    line-height: 25.05px;
    text-align: center;
    color: #425166;
}


.current_job_card {
    display: flex;
    flex-direction: column;
    /* width: 264px;
    height: 264px; */
    padding: 20px;
    gap: 10px;
    border-radius: 15px;
    border: 0.75px;
    opacity: 0px;
    background: #FFFFFF;
    box-shadow: 0px 3px 15px 0px #EEEEEE80;

}

.current_job_card .content {
    display: flex;
    flex-direction: column;
    /* width: 224px;
    height: 224px; */
    gap: 20px;
    opacity: 0px;
}

.current_job_card .content .content_heading {
    display: flex;
    flex-direction: row;
    /* width: 224px; */
    height: 56px;
    gap: 6px;
    opacity: 0px;
    justify-content: space-between;

}

.heading_name {
    /* width: 112px; */
    display: flex;
    flex-direction: column;
    height: 53px;
    gap: 6px;
    opacity: 0px;

}

.time_address {
    /* width: 106px; */
    display: flex;
    flex-direction: column;
    height: 56px;
    gap: 10px;
    opacity: 0px;

}

.heading {
    width: 112px;
    height: 24px;
    gap: 0px;
    opacity: 0px;
    font-family: Poppins;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #05004E;

}

.para_text_left {
    width: 112px;
    height: 23px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 12px;
    font-weight: 400;
    line-height: 22.5px;
    text-align: left;
    color: #737791;
}

.para_text_right {
    width: 112px;
    height: 23px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 12px;
    font-weight: 400;
    line-height: 22.5px;
    text-align: right;
    color: #737791;
}


/* available amount card */

.complete_circle {
    /* stroke-dasharray: 113;
    stroke-dashoffset: 0;
    animation: countdown 2400s linear forwards; */
    width: 120px;
    height: 120px;
    gap: 0px;
    opacity: 0px;
    margin: 0 auto;
}

.complete_circle .total_amount {
    display: flex;
    width: 69px;
    height: 43px;
    top: 235px;
    left: 516px;
    gap: 1.39px;
    opacity: 0px;
    position: absolute;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
}

.complete_circle .total_amount .amount {
    width: 82px;
    height: 34px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 20px;
    font-weight: 600;
    line-height: 33.4px;
    text-align: center;
    color: #151D48;
}

.available_balance_card {
    display: flex;
    flex-direction: column;
    /* width: 264px;
    height: 264px; */
    padding: 20px;
    gap: 10px;
    border-radius: 15px;
    border: 0.75px;
    opacity: 0px;
    background: #FFFFFF;
    box-shadow: 0px 3px 15px 0px #EEEEEE80;

}

.available_balance_card .content {
    display: flex;
    flex-direction: column;
    /* width: 224px;
    height: 224px; */
    gap: 20px;
    opacity: 0px;
}

.available_balance_card .content .content_heading {
    display: flex;
    flex-direction: row;
    /* width: 224px; */
    height: 56px;
    gap: 6px;
    opacity: 0px;
    justify-content: space-between;
}

.available_balance_card .content .content_heading .heading_name {
    /* width: 112px; */
    display: flex;
    flex-direction: column;
    height: 53px;
    gap: 6px;
    opacity: 0px;

}

.available_balance_card .content .content_heading .heading {
    width: auto;
    height: 24px;
    gap: 0px;
    opacity: 0px;
    font-family: Poppins;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #05004E;

}

.available_balance_card .content .content_heading .para_text_left {
    width: auto;
    height: 23px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 12px;
    font-weight: 400;
    line-height: 22.5px;
    text-align: left;
    color: #737791;
}

.available_balance_card .complete-circle {
    width: 120px;
    height: 120px;
    gap: 0px;
    opacity: 0px;
    margin: 0 auto;
}

.available_balance_card .total_amount {
    position: relative;
    top: -75px;
    left: 15px;
}

.available_balance_card .total_amount .amount {
    width: 87px;
    height: 34px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 24px;
    font-weight: 300;
    line-height: 33.4px;
    text-align: left;
    color: #151D48;
}

.available_balance_card .total_amount .amount span {
    width: 87px;
    height: 34px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 32px;
    font-weight: 600;
    line-height: 33.4px;
    text-align: left;
    color: #151D48;
}


/* upcoming job card */

.upcoming_job {
    /* width: 456px; */
    height: 264px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 15px;
    opacity: 0px;
    background: #FFFFFF;
    box-shadow: 0px 3px 15px 0px #EEEEEE80;
}

.upcoming_job .upcoming_job_head {
    width: 125px;
    height: 24.07px;
    gap: 20px;
    opacity: 0px;
    font-family: Poppins;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #05004E;
}

.upcoming_job .upcoming_job_block {
    display: flex;
    /* width: 416px; */
    height: 48px;
    padding: 9px 8px 9px 8px;
    gap: 0px;
    border-radius: 5px;
    border: 2px;
    justify-content: space-between;
    opacity: 0px;

    border: 2px solid #F3E8FF
}

.upcoming_job .upcoming_job_block .upcoming_job_time {
    width: 65px;
    height: 30px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 16px;
    font-weight: 400;
    line-height: 15px;
    text-align: left;
    color: #151D48;

}

.upcoming_job .upcoming_job_block .upcoming_job_description {
    width: 95.73px;
    height: 30px;
    gap: 0px;
    opacity: 0px;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 15px;
    text-align: left;
    color: #151D48;
}


.upcoming_job .upcoming_job_block .upcoming_job_address {
    width: 104px;
    height: 30px;
    gap: 0px;
    opacity: 0px;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 15px;
    text-align: left;
    color: #151D48;
}

/* income card */

.income {
    /* width: 543.33px; */
    height: 266px;
    padding: 30px;
    gap: 10px;
    border-radius: 15px;
    border: 0.75px;
    opacity: 0px;
    border: 0.75px solid #F8F9FA;
    background: #FFFFFF;
    box-shadow: 0px 3px 15px 0px #EEEEEE80;
}

.income .income_inner_card {
    display: flex;
    flex-direction: column;
    /* width: 483.33px; */
    height: 185.33px;
    gap: 40px;
    opacity: 0px;
}

.income .income_inner_card .income_head {
    display: flex;
    width: 62px;
    height: 24px;
    gap: 32px;
    opacity: 0px;
}

.income .income_inner_card .income_head span {
    width: 62px;
    height: 24px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #05004E;
}

.income .income_inner_card .income_body {
    display: flex;
    flex-direction: row;
    /* width: 483.33px; */
    height: 121.33px;
    padding: 0px 11px 0px 11px;
    gap: 36px;
    opacity: 0px;
}

.income .income_inner_card .income_body .income_body_inner {
    display: flex;
    flex-direction: column;
    /* width: 461.33px; */
    height: 121.33px;
    /* gap: 36px; */
    opacity: 0px;

}

/* .income .income_inner_card .income_body .income_body_inner {
    width: 88.33px;
    height: 88.33px;
    gap: 0px;
    opacity: 0px;
    border: 11px solid #FF947A;
} */

.income .income_inner_card .income_body .income_body_inner,
.income .income_inner_card .income_body .income_body_inner img {
    width: 88.33px;
    height: 88.33px;
    gap: 0px;
    opacity: 0px;
}

.income .income_inner_card .income_body .income_body_inner div {
    width: 55.94px;
    height: 31.65px;
    /* top: 28.71px; */
    top: -56.71px;
    left: 13.19px;
    opacity: 0px;
    position: relative;

    .curr_sign {
        width: 66px;
        height: 25px;
        gap: 0px;
        opacity: 0px;
        font-family: Lexend;
        font-size: 12px;
        font-weight: 600;
        line-height: 24.16px;
        text-align: left;
        color: #151D48;
    }

    .income_amount {
        width: 66px;
        height: 25px;
        gap: 0px;
        opacity: 0px;
        font-family: Lexend;
        font-size: 20px;
        font-weight: 600;
        line-height: 24.16px;
        text-align: left;

        color: #151D48;
    }
}

.income .income_inner_card .income_body .income_body_inner .income_description {
    /* width: 75px; */
    height: 14px;
    gap: 0px;
    opacity: 0px;
    font-family: Lexend;
    font-size: 12px;
    font-weight: 500;
    line-height: 13.25px;
    text-align: left;
    color: #737791;
    display: flex;
    align-items: center;
    justify-content: space-around;

}


/* Overall Score */


.overall {
    display: flex;
    flex-direction: row;
    /* width: 456px; */
    width: 100%;
    height: 266px;
    top: 397px;
    left: 958px;
    gap: 64px;
    border-radius: 15px;
    border: 0.75px;
    opacity: 0px;
    background: #FFFFFF;
    border: 0.75px solid #F8F9FA;
    box-shadow: 0px 3px 12px 0px #EEEEEE80;

    .monthly_block {
        display: flex;
        flex-direction: column;
        /* width: 124px; */
        width: 100%;
        height: 206px;
        top: 427px;
        left: 991.33px;
        gap: 0px;
        justify-content: space-between;
        opacity: 0px;

        .monthly_text {
            /* width: 115px; */
            width: 100%;
            height: 24px;
            gap: 32px;
            opacity: 0px;
            font-family: Lexend;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            color: #05004E;

        }

        .monthly_rating {
            display: flex;
            flex-direction: column;
            /* width: 124px; */
            width: 100%;
            height: 55px;
            gap: 12px;
            opacity: 0px;
            align-items: center;

            .rating_text {
                /* width: 92px; */
                width: 100%;
                height: 24px;
                gap: 0px;
                opacity: 0px;

                .total_rating {
                    font-family: Lexend;
                    font-size: 40px;
                    font-weight: 500;
                    line-height: 24px;
                    text-align: left;
                }

                .out_of {
                    font-family: Lexend;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;

                }
            }
        }

        .monthly_reviews {
            /* width: 124px; */
            width: 100%;
            height: 36px;
            gap: 32px;
            border-radius: 6px;
            opacity: 0px;
            background: #DCFCE7;
            padding: 4px;

            .reviews {
                /* width: 108px; */
                width: 100%;
                height: 24px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 20px;
                font-weight: 500;
                line-height: 24px;
                text-align: left;
                color: #05004E;

            }
        }
    }

    .vertical_line {
        width: 0px;
        height: 70px;
        top: 495px;
        left: 1186px;
        gap: 0px;
        border: 1px;
        opacity: 0px;
        transform: 90deg;
        border: 1px solid #CFCFCF;
        margin: auto 0;
    }

    .yearly_block {
        display: flex;
        flex-direction: column;
        /* width: 124px; */
        width: 100%;
        height: 206px;
        top: 427px;
        left: 991.33px;
        gap: 0px;
        justify-content: space-between;
        opacity: 0px;

        .yearly_text {
            /* width: 115px; */
            width: 100%;
            height: 24px;
            gap: 32px;
            opacity: 0px;
            font-family: Lexend;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            color: #05004E;

        }

        .yearly_rating {
            display: flex;
            flex-direction: column;
            /* width: 124px; */
            width: 100%;
            height: 55px;
            gap: 12px;
            opacity: 0px;
            align-items: center;

            .rating_text {
                /* width: 92px; */
                width: 100%;
                height: 24px;
                gap: 0px;
                opacity: 0px;

                .total_rating {
                    font-family: Lexend;
                    font-size: 40px;
                    font-weight: 500;
                    line-height: 24px;
                    text-align: left;
                }

                .out_of {
                    font-family: Lexend;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;

                }
            }
        }

        .yearly_reviews {
            /* width: 124px; */
            width: 100%;
            height: 36px;
            gap: 32px;
            border-radius: 6px;
            opacity: 0px;
            background: #DCFCE7;
            padding: 4px;

            .reviews {
                /* width: 108px; */
                width: 100%;
                height: 24px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 20px;
                font-weight: 500;
                line-height: 24px;
                text-align: left;
                color: #05004E;

            }
        }
    }
}


/* week at glance */

.week_glance {
    display: flex;
    flex-direction: column;
    /* width: 486px; */
    height: 232px;
    top: 682.67px;
    left: 398px;
    padding: 20px 24px 20px 24px;
    gap: 0px;
    border-radius: 15px;
    /* border: 0.75px ; */
    justify-content: space-between;
    opacity: 0px;
    background: #FFFFFF;
    border: 0.75px solid #F8F9FA;
    box-shadow: 0px 3px 15px 0px #EEEEEE80;

    .week_body {
        display: flex;
        flex-direction: column;
        /* width: 490px; */
        width: 100%;
        height: 192px;
        gap: 30px;
        opacity: 0px;


        .week_glance_head {
            display: flex;
            /* width: 276px; */
            width: 100%;
            height: 24px;
            gap: 32px;
            opacity: 0px;

            .week_heading {
                width: 142px;
                height: 24px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                text-align: left;
                color: #05004E;
            }

            .job_summary {
                width: 102px;
                height: 23px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 14px;
                font-weight: 400;
                line-height: 22.5px;
                text-align: left;
                color: #737791;
            }
        }

        .week_glance_content {
            display: flex;
            /* width: 490px; */
            width: 100%;
            height: 138px;
            gap: 20px;
            opacity: 0px;

            .total_jobs {
                display: flex;
                flex-direction: column;
                /* width: 150px; */
                width: 100%;
                height: 138px;
                gap: 10px;
                border-radius: 12px;
                opacity: 0px;
                background: #FFF4DE;
                padding: 15px;

                img {
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                }

                .count {
                    width: 12px;
                    height: 24px;
                    top: 57px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;
                    color: #151D48;

                }

                .head {
                    width: 63px;
                    height: 18px;
                    top: 87px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: left;
                    color: #425166;

                }

                .description {
                    width: 89px;
                    height: 12px;
                    top: 111px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 9px;
                    font-weight: 500;
                    line-height: 12px;
                    text-align: left;
                    color: #4079ED;

                }
            }

            .jobs_completed {
                display: flex;
                flex-direction: column;
                /* width: 150px; */
                width: 100%;
                height: 138px;
                gap: 10px;
                border-radius: 12px;
                opacity: 0px;
                background: #DCFCE7;
                padding: 15px;

                img {
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                }

                .count {
                    width: 12px;
                    height: 24px;
                    top: 57px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;
                    color: #151D48;

                }

                .head {
                    width: 101px;
                    height: 18px;
                    top: 87px;
                    left: 170px;
                    gap: 0px;
                    opacity: 0px;

                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: left;
                    color: #425166;

                }

                .description {
                    width: 93px;
                    height: 12px;
                    top: 111px;
                    left: 170px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 9px;
                    font-weight: 500;
                    line-height: 12px;
                    text-align: left;
                    color: #4079ED;

                }
            }

            .jobs_cancelled {
                display: flex;
                flex-direction: column;
                /* width: 150px; */
                width: 100%;
                height: 138px;
                gap: 10px;
                border-radius: 12px;
                opacity: 0px;
                background: #F3E8FF;
                padding: 15px;

                img {
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                }

                .count {
                    width: 12px;
                    height: 24px;
                    top: 57px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;
                    color: #151D48;

                }

                .head {
                    width: 94px;
                    height: 18px;
                    top: 87px;
                    left: 325px;
                    gap: 0px;
                    opacity: 0px;


                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: left;
                    color: #425166;

                }

                .description {
                    width: 89px;
                    height: 12px;
                    top: 111px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 9px;
                    font-weight: 500;
                    line-height: 12px;
                    text-align: left;
                    color: #4079ED;

                }
            }
        }
    }
}

/* month at glance */

.month_glance {
    display: flex;
    flex-direction: column;
    /* width: 510px; */
    height: 232px;
    top: 682.67px;
    left: 398px;
    padding: 20px 24px 20px 24px;
    gap: 0px;
    border-radius: 15px;
    /* border: 0.75px ; */
    justify-content: space-between;
    opacity: 0px;
    background: #FFFFFF;
    border: 0.75px solid #F8F9FA;
    box-shadow: 0px 3px 15px 0px #EEEEEE80;


    .month_body {
        display: flex;
        flex-direction: column;
        /* width: 490px; */
        width: 100%;
        height: 192px;
        gap: 30px;
        opacity: 0px;

        .month_glance_head {
            display: flex;
            /* width: 282px; */
            width: 100%;
            height: 24px;
            gap: 32px;
            opacity: 0px;


            .month_heading {
                width: 148px;
                height: 24px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                text-align: left;
                color: #05004E;

            }

            .job_summary {
                width: 102px;
                height: 23px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 14px;
                font-weight: 400;
                line-height: 22.5px;
                text-align: left;
                color: #737791;

            }
        }

        .month_glance_content {
            display: flex;
            /* width: 490px; */
            width: 100%;
            height: 138px;
            gap: 20px;
            opacity: 0px;

            .total_jobs {
                display: flex;
                flex-direction: column;
                /* width: 150px; */
                width: 100%;
                height: 138px;
                gap: 10px;
                border-radius: 12px;
                opacity: 0px;
                background: #FFF4DE;
                padding: 15px;

                img {
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                }

                .count {
                    width: 23px;
                    height: 24px;
                    top: 57px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;
                    color: #151D48;

                }

                .head {
                    width: 63px;
                    height: 18px;
                    top: 87px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: left;
                    color: #425166;

                }

                .description {
                    width: 95px;
                    height: 12px;
                    top: 111px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 9px;
                    font-weight: 500;
                    line-height: 12px;
                    text-align: left;
                    color: #4079ED;

                }
            }

            .jobs_completed {
                display: flex;
                flex-direction: column;
                /* width: 150px; */
                width: 100%;
                height: 138px;
                gap: 10px;
                border-radius: 12px;
                opacity: 0px;
                background: #DCFCE7;
                padding: 15px;

                img {
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                }

                .count {
                    width: 22px;
                    height: 24px;
                    top: 57px;
                    left: 170px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;
                    color: #151D48;

                }

                .head {
                    width: 101px;
                    height: 18px;
                    top: 87px;
                    left: 170px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: left;
                    color: #425166;

                }

                .description {
                    width: 100px;
                    height: 12px;
                    top: 111px;
                    left: 170px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 9px;
                    font-weight: 500;
                    line-height: 12px;
                    text-align: left;
                    color: #4079ED;

                }
            }

            .jobs_cancelled {
                display: flex;
                flex-direction: column;
                /* width: 150px; */
                width: 100%;
                height: 138px;
                gap: 10px;
                border-radius: 12px;
                opacity: 0px;
                background: #F3E8FF;
                padding: 15px;

                img {
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                }

                .count {
                    width: 12px;
                    height: 24px;
                    top: 57px;
                    left: 15px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    text-align: left;
                    color: #151D48;

                }

                .head {
                    width: 94px;
                    height: 18px;
                    top: 87px;
                    left: 325px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: left;
                    color: #425166;

                }

                .description {
                    width: 95px;
                    height: 12px;
                    top: 111px;
                    left: 325px;
                    gap: 0px;
                    opacity: 0px;
                    font-family: Poppins;
                    font-size: 9px;
                    font-weight: 500;
                    line-height: 12px;
                    text-align: left;
                    color: #4079ED;

                }
            }
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;;GAEG;;AAEH;IACI;;iDAE6C;IAC7C,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb;iBACa;IACb,QAAQ;IACR,YAAY;;AAEhB;;AAEA;IACI,qDAAqD;IACrD,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,QAAQ;IACR,YAAY;;AAEhB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB;oBACgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;;AAE1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;oBACgB;IAChB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,8BAA8B;;AAElC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;IACR,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;;AAGA,0BAA0B;;AAE1B;IACI;;iDAE6C;IAC7C,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;oBACgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;;AAE1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;oBACgB;IAChB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;IACR,YAAY;;AAEhB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,SAAS;IACT,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,YAAY;;IAEZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,gBAAgB;;AAEhB;IACI,qBAAqB;IACrB,aAAa;IACb,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,YAAY;;AAEhB;;AAEA;;;;;;GAMG;;AAEH;;IAEI,cAAc;IACd,eAAe;IACf,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,kBAAkB;;IAElB;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;;QAEhB,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,6BAA6B;;AAEjC;;;AAGA,kBAAkB;;;AAGlB;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,sCAAsC;;IAEtC;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,UAAU;QACV,cAAc;QACd,QAAQ;QACR,8BAA8B;QAC9B,YAAY;;QAEZ;YACI,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,YAAY;YACZ,mBAAmB;YACnB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,YAAY;YACZ,mBAAmB;;YAEnB;gBACI,iBAAiB;gBACjB,WAAW;gBACX,YAAY;gBACZ,QAAQ;gBACR,YAAY;;gBAEZ;oBACI,mBAAmB;oBACnB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;gBACpB;;gBAEA;oBACI,mBAAmB;oBACnB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;;gBAEpB;YACJ;QACJ;;QAEA;YACI,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,kBAAkB;YAClB,YAAY;YACZ,mBAAmB;YACnB,YAAY;;YAEZ;gBACI,kBAAkB;gBAClB,WAAW;gBACX,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;;YAElB;QACJ;IACJ;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,UAAU;QACV,YAAY;QACZ,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,UAAU;QACV,cAAc;QACd,QAAQ;QACR,8BAA8B;QAC9B,YAAY;;QAEZ;YACI,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,YAAY;YACZ,mBAAmB;YACnB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;;QAElB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,YAAY;YACZ,mBAAmB;;YAEnB;gBACI,iBAAiB;gBACjB,WAAW;gBACX,YAAY;gBACZ,QAAQ;gBACR,YAAY;;gBAEZ;oBACI,mBAAmB;oBACnB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;gBACpB;;gBAEA;oBACI,mBAAmB;oBACnB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;;gBAEpB;YACJ;QACJ;;QAEA;YACI,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,kBAAkB;YAClB,YAAY;YACZ,mBAAmB;YACnB,YAAY;;YAEZ;gBACI,kBAAkB;gBAClB,WAAW;gBACX,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;;YAElB;QACJ;IACJ;AACJ;;;AAGA,mBAAmB;;AAEnB;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,sCAAsC;;IAEtC;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,SAAS;QACT,YAAY;;;QAGZ;YACI,aAAa;YACb,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,YAAY;;YAEZ;gBACI,YAAY;gBACZ,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;YAClB;;YAEA;gBACI,YAAY;gBACZ,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,mBAAmB;gBACnB,gBAAgB;gBAChB,cAAc;YAClB;QACJ;;QAEA;YACI,aAAa;YACb,kBAAkB;YAClB,WAAW;YACX,aAAa;YACb,SAAS;YACT,YAAY;;YAEZ;gBACI,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;gBAClB,WAAW;gBACX,aAAa;gBACb,SAAS;gBACT,mBAAmB;gBACnB,YAAY;gBACZ,mBAAmB;gBACnB,aAAa;;gBAEb;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;gBAChB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,UAAU;oBACV,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,cAAc;oBACd,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;YACJ;;YAEA;gBACI,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;gBAClB,WAAW;gBACX,aAAa;gBACb,SAAS;gBACT,mBAAmB;gBACnB,YAAY;gBACZ,mBAAmB;gBACnB,aAAa;;gBAEb;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;gBAChB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,YAAY;oBACZ,YAAY;oBACZ,SAAS;oBACT,WAAW;oBACX,QAAQ;oBACR,YAAY;;oBAEZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,UAAU;oBACV,WAAW;oBACX,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,cAAc;oBACd,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;YACJ;;YAEA;gBACI,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;gBAClB,WAAW;gBACX,aAAa;gBACb,SAAS;gBACT,mBAAmB;gBACnB,YAAY;gBACZ,mBAAmB;gBACnB,aAAa;;gBAEb;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;gBAChB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,WAAW;oBACX,QAAQ;oBACR,YAAY;;;oBAGZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,UAAU;oBACV,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,cAAc;oBACd,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;YACJ;QACJ;IACJ;AACJ;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,sCAAsC;;;IAGtC;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,SAAS;QACT,YAAY;;QAEZ;YACI,aAAa;YACb,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,SAAS;YACT,YAAY;;;YAGZ;gBACI,YAAY;gBACZ,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;;YAElB;;YAEA;gBACI,YAAY;gBACZ,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,mBAAmB;gBACnB,gBAAgB;gBAChB,cAAc;;YAElB;QACJ;;QAEA;YACI,aAAa;YACb,kBAAkB;YAClB,WAAW;YACX,aAAa;YACb,SAAS;YACT,YAAY;;YAEZ;gBACI,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;gBAClB,WAAW;gBACX,aAAa;gBACb,SAAS;gBACT,mBAAmB;gBACnB,YAAY;gBACZ,mBAAmB;gBACnB,aAAa;;gBAEb;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;gBAChB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,UAAU;oBACV,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,cAAc;oBACd,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;YACJ;;YAEA;gBACI,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;gBAClB,WAAW;gBACX,aAAa;gBACb,SAAS;gBACT,mBAAmB;gBACnB,YAAY;gBACZ,mBAAmB;gBACnB,aAAa;;gBAEb;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;gBAChB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,WAAW;oBACX,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,YAAY;oBACZ,YAAY;oBACZ,SAAS;oBACT,WAAW;oBACX,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,YAAY;oBACZ,YAAY;oBACZ,UAAU;oBACV,WAAW;oBACX,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,cAAc;oBACd,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;YACJ;;YAEA;gBACI,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;gBAClB,WAAW;gBACX,aAAa;gBACb,SAAS;gBACT,mBAAmB;gBACnB,YAAY;gBACZ,mBAAmB;gBACnB,aAAa;;gBAEb;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;gBAChB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,UAAU;oBACV,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,SAAS;oBACT,WAAW;oBACX,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,eAAe;oBACf,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;;gBAEA;oBACI,WAAW;oBACX,YAAY;oBACZ,UAAU;oBACV,WAAW;oBACX,QAAQ;oBACR,YAAY;oBACZ,oBAAoB;oBACpB,cAAc;oBACd,gBAAgB;oBAChB,iBAAiB;oBACjB,gBAAgB;oBAChB,cAAc;;gBAElB;YACJ;QACJ;IACJ;AACJ","sourcesContent":["/* .dashboard_main {\n    margin-top: 5.5rem;\n} */\n\n/* .dashboard {\n    margin-left: 23.25rem;\n} */\n\n.countdown-circle {\n    /* stroke-dasharray: 113;\n    stroke-dashoffset: 0;\n    animation: countdown 2400s linear forwards; */\n    width: 120px;\n    height: 120px;\n    gap: 0px;\n    opacity: 0px;\n    margin: 0 auto;\n}\n\n.countdown-circle img {\n    width: 120px;\n    height: 120px;\n    /* top: 76px;\n    left: 52px; */\n    gap: 0px;\n    opacity: 0px;\n\n}\n\n.pointer {\n    /* animation: rotate-pointer 2400s linear forwards; */\n    /* transform-origin: center; */\n    width: 27.83px;\n    height: 27.83px;\n    gap: 0px;\n    opacity: 0px;\n\n}\n\n.pointer .pointer_img {\n    width: 27.83px;\n    height: 27.83px;\n    gap: 0px;\n    opacity: 0px;\n    position: relative;\n    top: -88px;\n    left: 0px;\n}\n\n.remaining_time {\n    display: flex;\n    width: 69px;\n    height: 43px;\n    top: -80.625%;\n    left: 21.6%;\n    gap: 1.39px;\n    opacity: 0px;\n    position: relative;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: nowrap;\n}\n\n.remaining_time .time {\n    width: 82px;\n    height: 34px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 33.4px;\n    text-align: center;\n    color: #151D48;\n}\n\n.remaining_time .text {\n    width: 77px;\n    height: 26px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 25.05px;\n    text-align: center;\n    color: #425166;\n}\n\n\n.current_job_card {\n    display: flex;\n    flex-direction: column;\n    /* width: 264px;\n    height: 264px; */\n    padding: 20px;\n    gap: 10px;\n    border-radius: 15px;\n    border: 0.75px;\n    opacity: 0px;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 15px 0px #EEEEEE80;\n\n}\n\n.current_job_card .content {\n    display: flex;\n    flex-direction: column;\n    /* width: 224px;\n    height: 224px; */\n    gap: 20px;\n    opacity: 0px;\n}\n\n.current_job_card .content .content_heading {\n    display: flex;\n    flex-direction: row;\n    /* width: 224px; */\n    height: 56px;\n    gap: 6px;\n    opacity: 0px;\n    justify-content: space-between;\n\n}\n\n.heading_name {\n    /* width: 112px; */\n    display: flex;\n    flex-direction: column;\n    height: 53px;\n    gap: 6px;\n    opacity: 0px;\n\n}\n\n.time_address {\n    /* width: 106px; */\n    display: flex;\n    flex-direction: column;\n    height: 56px;\n    gap: 10px;\n    opacity: 0px;\n\n}\n\n.heading {\n    width: 112px;\n    height: 24px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Poppins;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #05004E;\n\n}\n\n.para_text_left {\n    width: 112px;\n    height: 23px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 22.5px;\n    text-align: left;\n    color: #737791;\n}\n\n.para_text_right {\n    width: 112px;\n    height: 23px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 22.5px;\n    text-align: right;\n    color: #737791;\n}\n\n\n/* available amount card */\n\n.complete_circle {\n    /* stroke-dasharray: 113;\n    stroke-dashoffset: 0;\n    animation: countdown 2400s linear forwards; */\n    width: 120px;\n    height: 120px;\n    gap: 0px;\n    opacity: 0px;\n    margin: 0 auto;\n}\n\n.complete_circle .total_amount {\n    display: flex;\n    width: 69px;\n    height: 43px;\n    top: 235px;\n    left: 516px;\n    gap: 1.39px;\n    opacity: 0px;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: nowrap;\n}\n\n.complete_circle .total_amount .amount {\n    width: 82px;\n    height: 34px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 33.4px;\n    text-align: center;\n    color: #151D48;\n}\n\n.available_balance_card {\n    display: flex;\n    flex-direction: column;\n    /* width: 264px;\n    height: 264px; */\n    padding: 20px;\n    gap: 10px;\n    border-radius: 15px;\n    border: 0.75px;\n    opacity: 0px;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 15px 0px #EEEEEE80;\n\n}\n\n.available_balance_card .content {\n    display: flex;\n    flex-direction: column;\n    /* width: 224px;\n    height: 224px; */\n    gap: 20px;\n    opacity: 0px;\n}\n\n.available_balance_card .content .content_heading {\n    display: flex;\n    flex-direction: row;\n    /* width: 224px; */\n    height: 56px;\n    gap: 6px;\n    opacity: 0px;\n    justify-content: space-between;\n}\n\n.available_balance_card .content .content_heading .heading_name {\n    /* width: 112px; */\n    display: flex;\n    flex-direction: column;\n    height: 53px;\n    gap: 6px;\n    opacity: 0px;\n\n}\n\n.available_balance_card .content .content_heading .heading {\n    width: auto;\n    height: 24px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Poppins;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #05004E;\n\n}\n\n.available_balance_card .content .content_heading .para_text_left {\n    width: auto;\n    height: 23px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 22.5px;\n    text-align: left;\n    color: #737791;\n}\n\n.available_balance_card .complete-circle {\n    width: 120px;\n    height: 120px;\n    gap: 0px;\n    opacity: 0px;\n    margin: 0 auto;\n}\n\n.available_balance_card .total_amount {\n    position: relative;\n    top: -75px;\n    left: 15px;\n}\n\n.available_balance_card .total_amount .amount {\n    width: 87px;\n    height: 34px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 24px;\n    font-weight: 300;\n    line-height: 33.4px;\n    text-align: left;\n    color: #151D48;\n}\n\n.available_balance_card .total_amount .amount span {\n    width: 87px;\n    height: 34px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 33.4px;\n    text-align: left;\n    color: #151D48;\n}\n\n\n/* upcoming job card */\n\n.upcoming_job {\n    /* width: 456px; */\n    height: 264px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    border-radius: 15px;\n    opacity: 0px;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 15px 0px #EEEEEE80;\n}\n\n.upcoming_job .upcoming_job_head {\n    width: 125px;\n    height: 24.07px;\n    gap: 20px;\n    opacity: 0px;\n    font-family: Poppins;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #05004E;\n}\n\n.upcoming_job .upcoming_job_block {\n    display: flex;\n    /* width: 416px; */\n    height: 48px;\n    padding: 9px 8px 9px 8px;\n    gap: 0px;\n    border-radius: 5px;\n    border: 2px;\n    justify-content: space-between;\n    opacity: 0px;\n\n    border: 2px solid #F3E8FF\n}\n\n.upcoming_job .upcoming_job_block .upcoming_job_time {\n    width: 65px;\n    height: 30px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 15px;\n    text-align: left;\n    color: #151D48;\n\n}\n\n.upcoming_job .upcoming_job_block .upcoming_job_description {\n    width: 95.73px;\n    height: 30px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Poppins;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 15px;\n    text-align: left;\n    color: #151D48;\n}\n\n\n.upcoming_job .upcoming_job_block .upcoming_job_address {\n    width: 104px;\n    height: 30px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Poppins;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 15px;\n    text-align: left;\n    color: #151D48;\n}\n\n/* income card */\n\n.income {\n    /* width: 543.33px; */\n    height: 266px;\n    padding: 30px;\n    gap: 10px;\n    border-radius: 15px;\n    border: 0.75px;\n    opacity: 0px;\n    border: 0.75px solid #F8F9FA;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 15px 0px #EEEEEE80;\n}\n\n.income .income_inner_card {\n    display: flex;\n    flex-direction: column;\n    /* width: 483.33px; */\n    height: 185.33px;\n    gap: 40px;\n    opacity: 0px;\n}\n\n.income .income_inner_card .income_head {\n    display: flex;\n    width: 62px;\n    height: 24px;\n    gap: 32px;\n    opacity: 0px;\n}\n\n.income .income_inner_card .income_head span {\n    width: 62px;\n    height: 24px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #05004E;\n}\n\n.income .income_inner_card .income_body {\n    display: flex;\n    flex-direction: row;\n    /* width: 483.33px; */\n    height: 121.33px;\n    padding: 0px 11px 0px 11px;\n    gap: 36px;\n    opacity: 0px;\n}\n\n.income .income_inner_card .income_body .income_body_inner {\n    display: flex;\n    flex-direction: column;\n    /* width: 461.33px; */\n    height: 121.33px;\n    /* gap: 36px; */\n    opacity: 0px;\n\n}\n\n/* .income .income_inner_card .income_body .income_body_inner {\n    width: 88.33px;\n    height: 88.33px;\n    gap: 0px;\n    opacity: 0px;\n    border: 11px solid #FF947A;\n} */\n\n.income .income_inner_card .income_body .income_body_inner,\n.income .income_inner_card .income_body .income_body_inner img {\n    width: 88.33px;\n    height: 88.33px;\n    gap: 0px;\n    opacity: 0px;\n}\n\n.income .income_inner_card .income_body .income_body_inner div {\n    width: 55.94px;\n    height: 31.65px;\n    /* top: 28.71px; */\n    top: -56.71px;\n    left: 13.19px;\n    opacity: 0px;\n    position: relative;\n\n    .curr_sign {\n        width: 66px;\n        height: 25px;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Lexend;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 24.16px;\n        text-align: left;\n        color: #151D48;\n    }\n\n    .income_amount {\n        width: 66px;\n        height: 25px;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Lexend;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 24.16px;\n        text-align: left;\n\n        color: #151D48;\n    }\n}\n\n.income .income_inner_card .income_body .income_body_inner .income_description {\n    /* width: 75px; */\n    height: 14px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Lexend;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 13.25px;\n    text-align: left;\n    color: #737791;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n}\n\n\n/* Overall Score */\n\n\n.overall {\n    display: flex;\n    flex-direction: row;\n    /* width: 456px; */\n    width: 100%;\n    height: 266px;\n    top: 397px;\n    left: 958px;\n    gap: 64px;\n    border-radius: 15px;\n    border: 0.75px;\n    opacity: 0px;\n    background: #FFFFFF;\n    border: 0.75px solid #F8F9FA;\n    box-shadow: 0px 3px 12px 0px #EEEEEE80;\n\n    .monthly_block {\n        display: flex;\n        flex-direction: column;\n        /* width: 124px; */\n        width: 100%;\n        height: 206px;\n        top: 427px;\n        left: 991.33px;\n        gap: 0px;\n        justify-content: space-between;\n        opacity: 0px;\n\n        .monthly_text {\n            /* width: 115px; */\n            width: 100%;\n            height: 24px;\n            gap: 32px;\n            opacity: 0px;\n            font-family: Lexend;\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 24px;\n            text-align: left;\n            color: #05004E;\n\n        }\n\n        .monthly_rating {\n            display: flex;\n            flex-direction: column;\n            /* width: 124px; */\n            width: 100%;\n            height: 55px;\n            gap: 12px;\n            opacity: 0px;\n            align-items: center;\n\n            .rating_text {\n                /* width: 92px; */\n                width: 100%;\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n\n                .total_rating {\n                    font-family: Lexend;\n                    font-size: 40px;\n                    font-weight: 500;\n                    line-height: 24px;\n                    text-align: left;\n                }\n\n                .out_of {\n                    font-family: Lexend;\n                    font-size: 16px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n\n                }\n            }\n        }\n\n        .monthly_reviews {\n            /* width: 124px; */\n            width: 100%;\n            height: 36px;\n            gap: 32px;\n            border-radius: 6px;\n            opacity: 0px;\n            background: #DCFCE7;\n            padding: 4px;\n\n            .reviews {\n                /* width: 108px; */\n                width: 100%;\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 20px;\n                font-weight: 500;\n                line-height: 24px;\n                text-align: left;\n                color: #05004E;\n\n            }\n        }\n    }\n\n    .vertical_line {\n        width: 0px;\n        height: 70px;\n        top: 495px;\n        left: 1186px;\n        gap: 0px;\n        border: 1px;\n        opacity: 0px;\n        transform: 90deg;\n        border: 1px solid #CFCFCF;\n        margin: auto 0;\n    }\n\n    .yearly_block {\n        display: flex;\n        flex-direction: column;\n        /* width: 124px; */\n        width: 100%;\n        height: 206px;\n        top: 427px;\n        left: 991.33px;\n        gap: 0px;\n        justify-content: space-between;\n        opacity: 0px;\n\n        .yearly_text {\n            /* width: 115px; */\n            width: 100%;\n            height: 24px;\n            gap: 32px;\n            opacity: 0px;\n            font-family: Lexend;\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 24px;\n            text-align: left;\n            color: #05004E;\n\n        }\n\n        .yearly_rating {\n            display: flex;\n            flex-direction: column;\n            /* width: 124px; */\n            width: 100%;\n            height: 55px;\n            gap: 12px;\n            opacity: 0px;\n            align-items: center;\n\n            .rating_text {\n                /* width: 92px; */\n                width: 100%;\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n\n                .total_rating {\n                    font-family: Lexend;\n                    font-size: 40px;\n                    font-weight: 500;\n                    line-height: 24px;\n                    text-align: left;\n                }\n\n                .out_of {\n                    font-family: Lexend;\n                    font-size: 16px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n\n                }\n            }\n        }\n\n        .yearly_reviews {\n            /* width: 124px; */\n            width: 100%;\n            height: 36px;\n            gap: 32px;\n            border-radius: 6px;\n            opacity: 0px;\n            background: #DCFCE7;\n            padding: 4px;\n\n            .reviews {\n                /* width: 108px; */\n                width: 100%;\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 20px;\n                font-weight: 500;\n                line-height: 24px;\n                text-align: left;\n                color: #05004E;\n\n            }\n        }\n    }\n}\n\n\n/* week at glance */\n\n.week_glance {\n    display: flex;\n    flex-direction: column;\n    /* width: 486px; */\n    height: 232px;\n    top: 682.67px;\n    left: 398px;\n    padding: 20px 24px 20px 24px;\n    gap: 0px;\n    border-radius: 15px;\n    /* border: 0.75px ; */\n    justify-content: space-between;\n    opacity: 0px;\n    background: #FFFFFF;\n    border: 0.75px solid #F8F9FA;\n    box-shadow: 0px 3px 15px 0px #EEEEEE80;\n\n    .week_body {\n        display: flex;\n        flex-direction: column;\n        /* width: 490px; */\n        width: 100%;\n        height: 192px;\n        gap: 30px;\n        opacity: 0px;\n\n\n        .week_glance_head {\n            display: flex;\n            /* width: 276px; */\n            width: 100%;\n            height: 24px;\n            gap: 32px;\n            opacity: 0px;\n\n            .week_heading {\n                width: 142px;\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 16px;\n                font-weight: 600;\n                line-height: 24px;\n                text-align: left;\n                color: #05004E;\n            }\n\n            .job_summary {\n                width: 102px;\n                height: 23px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 22.5px;\n                text-align: left;\n                color: #737791;\n            }\n        }\n\n        .week_glance_content {\n            display: flex;\n            /* width: 490px; */\n            width: 100%;\n            height: 138px;\n            gap: 20px;\n            opacity: 0px;\n\n            .total_jobs {\n                display: flex;\n                flex-direction: column;\n                /* width: 150px; */\n                width: 100%;\n                height: 138px;\n                gap: 10px;\n                border-radius: 12px;\n                opacity: 0px;\n                background: #FFF4DE;\n                padding: 15px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    top: 15px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                }\n\n                .count {\n                    width: 12px;\n                    height: 24px;\n                    top: 57px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 18px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n                    color: #151D48;\n\n                }\n\n                .head {\n                    width: 63px;\n                    height: 18px;\n                    top: 87px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    text-align: left;\n                    color: #425166;\n\n                }\n\n                .description {\n                    width: 89px;\n                    height: 12px;\n                    top: 111px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 9px;\n                    font-weight: 500;\n                    line-height: 12px;\n                    text-align: left;\n                    color: #4079ED;\n\n                }\n            }\n\n            .jobs_completed {\n                display: flex;\n                flex-direction: column;\n                /* width: 150px; */\n                width: 100%;\n                height: 138px;\n                gap: 10px;\n                border-radius: 12px;\n                opacity: 0px;\n                background: #DCFCE7;\n                padding: 15px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    top: 15px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                }\n\n                .count {\n                    width: 12px;\n                    height: 24px;\n                    top: 57px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 18px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n                    color: #151D48;\n\n                }\n\n                .head {\n                    width: 101px;\n                    height: 18px;\n                    top: 87px;\n                    left: 170px;\n                    gap: 0px;\n                    opacity: 0px;\n\n                    font-family: Poppins;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    text-align: left;\n                    color: #425166;\n\n                }\n\n                .description {\n                    width: 93px;\n                    height: 12px;\n                    top: 111px;\n                    left: 170px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 9px;\n                    font-weight: 500;\n                    line-height: 12px;\n                    text-align: left;\n                    color: #4079ED;\n\n                }\n            }\n\n            .jobs_cancelled {\n                display: flex;\n                flex-direction: column;\n                /* width: 150px; */\n                width: 100%;\n                height: 138px;\n                gap: 10px;\n                border-radius: 12px;\n                opacity: 0px;\n                background: #F3E8FF;\n                padding: 15px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    top: 15px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                }\n\n                .count {\n                    width: 12px;\n                    height: 24px;\n                    top: 57px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 18px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n                    color: #151D48;\n\n                }\n\n                .head {\n                    width: 94px;\n                    height: 18px;\n                    top: 87px;\n                    left: 325px;\n                    gap: 0px;\n                    opacity: 0px;\n\n\n                    font-family: Poppins;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    text-align: left;\n                    color: #425166;\n\n                }\n\n                .description {\n                    width: 89px;\n                    height: 12px;\n                    top: 111px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 9px;\n                    font-weight: 500;\n                    line-height: 12px;\n                    text-align: left;\n                    color: #4079ED;\n\n                }\n            }\n        }\n    }\n}\n\n/* month at glance */\n\n.month_glance {\n    display: flex;\n    flex-direction: column;\n    /* width: 510px; */\n    height: 232px;\n    top: 682.67px;\n    left: 398px;\n    padding: 20px 24px 20px 24px;\n    gap: 0px;\n    border-radius: 15px;\n    /* border: 0.75px ; */\n    justify-content: space-between;\n    opacity: 0px;\n    background: #FFFFFF;\n    border: 0.75px solid #F8F9FA;\n    box-shadow: 0px 3px 15px 0px #EEEEEE80;\n\n\n    .month_body {\n        display: flex;\n        flex-direction: column;\n        /* width: 490px; */\n        width: 100%;\n        height: 192px;\n        gap: 30px;\n        opacity: 0px;\n\n        .month_glance_head {\n            display: flex;\n            /* width: 282px; */\n            width: 100%;\n            height: 24px;\n            gap: 32px;\n            opacity: 0px;\n\n\n            .month_heading {\n                width: 148px;\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 16px;\n                font-weight: 600;\n                line-height: 24px;\n                text-align: left;\n                color: #05004E;\n\n            }\n\n            .job_summary {\n                width: 102px;\n                height: 23px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 22.5px;\n                text-align: left;\n                color: #737791;\n\n            }\n        }\n\n        .month_glance_content {\n            display: flex;\n            /* width: 490px; */\n            width: 100%;\n            height: 138px;\n            gap: 20px;\n            opacity: 0px;\n\n            .total_jobs {\n                display: flex;\n                flex-direction: column;\n                /* width: 150px; */\n                width: 100%;\n                height: 138px;\n                gap: 10px;\n                border-radius: 12px;\n                opacity: 0px;\n                background: #FFF4DE;\n                padding: 15px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    top: 15px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                }\n\n                .count {\n                    width: 23px;\n                    height: 24px;\n                    top: 57px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 18px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n                    color: #151D48;\n\n                }\n\n                .head {\n                    width: 63px;\n                    height: 18px;\n                    top: 87px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    text-align: left;\n                    color: #425166;\n\n                }\n\n                .description {\n                    width: 95px;\n                    height: 12px;\n                    top: 111px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 9px;\n                    font-weight: 500;\n                    line-height: 12px;\n                    text-align: left;\n                    color: #4079ED;\n\n                }\n            }\n\n            .jobs_completed {\n                display: flex;\n                flex-direction: column;\n                /* width: 150px; */\n                width: 100%;\n                height: 138px;\n                gap: 10px;\n                border-radius: 12px;\n                opacity: 0px;\n                background: #DCFCE7;\n                padding: 15px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    top: 15px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                }\n\n                .count {\n                    width: 22px;\n                    height: 24px;\n                    top: 57px;\n                    left: 170px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 18px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n                    color: #151D48;\n\n                }\n\n                .head {\n                    width: 101px;\n                    height: 18px;\n                    top: 87px;\n                    left: 170px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    text-align: left;\n                    color: #425166;\n\n                }\n\n                .description {\n                    width: 100px;\n                    height: 12px;\n                    top: 111px;\n                    left: 170px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 9px;\n                    font-weight: 500;\n                    line-height: 12px;\n                    text-align: left;\n                    color: #4079ED;\n\n                }\n            }\n\n            .jobs_cancelled {\n                display: flex;\n                flex-direction: column;\n                /* width: 150px; */\n                width: 100%;\n                height: 138px;\n                gap: 10px;\n                border-radius: 12px;\n                opacity: 0px;\n                background: #F3E8FF;\n                padding: 15px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    top: 15px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                }\n\n                .count {\n                    width: 12px;\n                    height: 24px;\n                    top: 57px;\n                    left: 15px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 18px;\n                    font-weight: 600;\n                    line-height: 24px;\n                    text-align: left;\n                    color: #151D48;\n\n                }\n\n                .head {\n                    width: 94px;\n                    height: 18px;\n                    top: 87px;\n                    left: 325px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    text-align: left;\n                    color: #425166;\n\n                }\n\n                .description {\n                    width: 95px;\n                    height: 12px;\n                    top: 111px;\n                    left: 325px;\n                    gap: 0px;\n                    opacity: 0px;\n                    font-family: Poppins;\n                    font-size: 9px;\n                    font-weight: 500;\n                    line-height: 12px;\n                    text-align: left;\n                    color: #4079ED;\n\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
